export const MuiAccordionSummaryComponent = {
    styleOverrides: {
        root: {
            ".MuiAccordionSummary-content": {
                margin: "8px 0",
            },
        },
    },
};
